import React, { useEffect, useState } from "react";
import Image from "react-bootstrap/Image";
import styles from "./MediaItem.module.scss";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {
  MdShare,
  MdAdd,
  MdFavorite,
  MdPlaylistAddCheck,
  MdMusicNote,
  MdVideocam,
  MdOutlineModeComment,
  MdPlayArrow,
} from "react-icons/md";

import { ImSpinner10 } from "react-icons/im";

import { useDispatch, useSelector } from "react-redux";
import talent from "../../images/talent.png";
import { ROUTE_BASENAME } from "../../config/constants";
import {
  addToFavourite,
  addToList,
  addToViewed,
  removeFromList,
  addToListPodcast,
  addToViewedPodcast,
  addToFavouritePodcast,
  removeFromListPodcast,
} from "../../store/mediaMethods";

import { scrollTop } from "../../helper";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { setAudioPlayer } from "../../store/playerMethods";
import { playerActions } from "../../store/playerSlice";
import { mediaActions } from "../../store/mediaSlice";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePosted from "../ui/common/DatePosted";
import { Formik } from "formik";
import * as Yup from "yup";
import { sendFeedback } from "../../store/publicMethods";
import { toast } from "react-hot-toast";

function MediaItem(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isAddedToPlayListLoading, setAddedToPlayListLoading] = useState(false);

  const entity =
    props.type === "podcast"
      ? props.mediaData.podcast
      : props.mediaData.inhouse;

  const channel = props?.mediaData?.channel;

  const [show, setShow] = useState(false);
  const [feedbackShow, setFeedbackShow] = useState(false);

  const [isFavourite, setIsFavourite] = useState(entity?.is_favourite);

  const [isAddedToPlayList, setAddedToPlayList] = useState(entity?.is_playlist);

  const isAudio =entity?.raw_file_origin?.type?.indexOf("audio") !== -1 ? true : false;

  const addToListHandler = () => {
    setAddedToPlayListLoading(true);

    if (props.type === "podcast") {
      const values = {
        user: props?.mediaData?.user?.id,
        client_unit: entity?.uuid,
        client_superunit: channel?.uuid,
        selected_type: "PLAYLIST",
        title: entity?.title,
      };
      dispatch(addToListPodcast(values)).then(() => {
        setAddedToPlayList(!isAddedToPlayList);
        setAddedToPlayListLoading(false);
      });
    } else {
      const values = {
        user: props?.mediaData?.user?.id,
        client_inhouseunit: entity?.uuid,
        client_inhousesuperunit: channel?.uuid,
        selected_type: "PLAYLIST",
        title: entity?.title,
      };
      dispatch(addToList(values)).then(() => {
        setAddedToPlayList(!isAddedToPlayList);
        setAddedToPlayListLoading(false);
      });
    }
  };

  const addToFavouriteHandler = () => {
    setIsLoading(true);

    if (props.type === "podcast") {
      const values = {
        user: props?.mediaData?.user?.id,
        client_unit: entity?.uuid,
        client_superunit: channel?.uuid,
        selected_type: "FAVOURITE",
      };

      dispatch(addToFavouritePodcast(values)).then(() => {
        setIsFavourite(!isFavourite);
        setIsLoading(false);
      });
    } else {
      const values = {
        user: props?.mediaData?.user?.id,
        client_inhouseunit: entity?.uuid,
        client_inhousesuperunit: channel?.uuid,
        selected_type: "FAVOURITE",
      };

      dispatch(addToFavourite(values)).then(() => {
        setIsFavourite(!isFavourite);
        setIsLoading(false);
      });
    }
  };
  const addToViewedHandler = () => {
    if (props.type === "podcast") {
      const values = {
        user: props?.mediaData?.user?.id,
        client_unit: entity?.uuid,
        client_superunit: channel?.uuid,
        selected_type: "VIEWED",
      };
      dispatch(addToViewedPodcast(values));
    } else {
      const values = {
        user: props?.mediaData?.user?.id,
        client_inhouseunit: entity?.uuid,
        client_inhousesuperunit: channel?.uuid,
        selected_type: "VIEWED",
      };
      dispatch(addToViewed(values));
    }
  };

  const removeFromListHandler = () => {
    setAddedToPlayListLoading(true);
    if (props.type === "podcast") {
      const values = {
        user: props?.mediaData?.user?.id,
        client_unit: entity?.uuid,
        client_superunit: channel?.uuid,
        selected_type: "PLAYLIST",
        title: entity?.title,
      };

      dispatch(removeFromListPodcast(values)).then(() => {
        setAddedToPlayList(!isAddedToPlayList);
        setAddedToPlayListLoading(false);
      });
    } else {
      const values = {
        user: props?.mediaData?.user?.id,
        client_inhouseunit: entity?.uuid,
        client_inhousesuperunit: channel?.uuid,
        selected_type: "PLAYLIST",
        title: entity?.title,
      };

      dispatch(removeFromList(values)).then(() => {
        setAddedToPlayList(!isAddedToPlayList);
        setAddedToPlayListLoading(false);
      });
    }
  };

  const removeFromFavouriteHandler = () => {};
  const allThumbnails = [
    entity?.thumbnail_file_origin,
    ...Object.values(entity?.additional_thumbnail_files || {}),
  ];
  return (
    <>
      <div className={`${styles.mediaItem} hvr-grow`}>
        <div
          className={`position-relative rounded overflow-hidden`}
          onClick={() => {
            addToViewedHandler();
            if (props.playerType === "inline") {
              dispatch(
                playerActions.setAudioPlayer({
                  isPlaying: true,
                  url: entity?.raw_file_origin?.url?.split("?")[0],
                  title: entity?.title,
                  type:
                    entity?.raw_file_origin?.type.indexOf("audio") !== -1
                      ? "audio"
                      : "video",
                })
              );

              dispatch(
                mediaActions.setSelectedPodcast({
                  title: entity.title,
                  description: entity.description,
                  image: entity?.thumbnail_file_origin?.url?.split("?")[0],
                  is_playlist: entity?.is_playlist,
                  mediaData: props.mediaData,
                })
              );

              setTimeout(() => scrollTop(), 100);
            } else {
              if (props.type === "podcast") {
                navigate(`/podcaster/${entity?.uuid}`);
              } else {
                navigate(`/in-house/${entity?.uuid}`);
              }
            }
          }}
        >
          <div>
            <Link
              to={"#"}
              className="text-white stretched-link d-block h-100 w-100"
            >
              <div
                className={`ratio ${
                  props.shape === "rectangle" ? "ratio-4x3" : "ratio-4x3"
                }`}
              >
                <span className={styles.tag}>
                  {isAudio ? <MdMusicNote /> : <MdVideocam />}
                </span>
                {/* {console.log(entity?.additional_thumbnail_files?.length)} */}
                <Image
                  src={
                    (entity?.additional_thumbnail_files?.length > 0
                      ? allThumbnails[
                          Math.floor(Math.random() * allThumbnails.length)
                        ]?.url?.split("?")[0]
                      : entity?.thumbnail_file_origin?.url?.split("?")[0]) ||
                    talent
                  }
                  className={`m-auto ${styles.img}`}
                />
              </div>
            </Link>{" "}
          </div>

          <div
            className={`${styles.title} smooth ${
              props.shape === "rectangle" && styles.chanRec
            }`}
          >
            <Link to={"#"} className="text-white stretched-link">
              {entity?.title}
            </Link>
          </div>
        </div>

        <div className={`d-flex ${styles.cta}`}>
          <OverlayTrigger overlay={<Tooltip>Play</Tooltip>}>
            <span
              onClick={() => {
                addToViewedHandler();
                if (props.playerType === "inline") {
                  dispatch(
                    playerActions.setAudioPlayer({
                      isPlaying: true,
                      url: entity?.raw_file_origin?.url?.split("?")[0], // Add additional check
                      title: entity?.title,
                      type:
                        entity?.raw_file_origin?.type?.indexOf("audio") !== -1
                          ? "audio"
                          : "video",
                    })
                  );

                  dispatch(
                    mediaActions.setSelectedPodcast({
                      title: entity.title,
                      description: entity.description,
                      image: entity?.thumbnail_file_origin?.url?.split("?")[0],
                      is_playlist: entity?.is_playlist,
                      mediaData: props.mediaData,
                    })
                  );

                  setTimeout(() => scrollTop(), 100);
                } else {
                  if (props.type === "podcast") {
                    navigate(`/podcaster/${entity?.uuid}`);
                  } else {
                    navigate(`/in-house/${entity?.uuid}`);
                  }
                }
              }}
              className={`${styles.playButton}`}
            >
              <MdPlayArrow className="lead" style={{ fontSize: "1.5rem" }} />
            </span>
          </OverlayTrigger>
          <div className="ms-auto">
            <OverlayTrigger overlay={<Tooltip>Add Feedback</Tooltip>}>
              <span>
                <MdOutlineModeComment
                  className="lead"
                  onClick={() => setFeedbackShow(true)}
                />
              </span>
            </OverlayTrigger>
            {isAddedToPlayListLoading && (
              <span>
                <ImSpinner10
                  className="lead ms-2 icon-spinner"
                  style={{ left: "25%", top: "18%" }}
                />
              </span>
            )}

            {!isAddedToPlayListLoading &&
              (isAddedToPlayList ? (
                <OverlayTrigger
                  overlay={<Tooltip>Remove from Favourites</Tooltip>}
                >
                  <span>
                    <MdPlaylistAddCheck
                      className="lead ms-2"
                      onClick={() => removeFromListHandler()}
                      style={{ fontSize: "1.5rem" }}
                    />
                  </span>
                </OverlayTrigger>
              ) : (
                <OverlayTrigger overlay={<Tooltip>Add to Favourites</Tooltip>}>
                  <span>
                    <MdAdd
                      className="lead ms-2"
                      onClick={() => addToListHandler()}
                      style={{ fontSize: "1.5rem" }}
                    />
                  </span>
                </OverlayTrigger>
              ))}

            {isLoading ? (
              <span>
                <ImSpinner10
                  className="lead ms-2 icon-spinner"
                  style={{ left: "25%", top: "18%" }}
                />
              </span>
            ) : (
              <OverlayTrigger
                overlay={
                  <Tooltip>{isFavourite ? "You liked this!" : "Like"}</Tooltip>
                }
              >
                <span>
                  <MdFavorite
                    className={` lead ms-2 ${isFavourite && "text-danger"}`}
                    onClick={() =>
                      isFavourite
                        ? removeFromFavouriteHandler()
                        : addToFavouriteHandler()
                    }
                  />
                </span>
              </OverlayTrigger>
            )}
          </div>
        </div>

        <div
          className={`${styles.moreInfo} position-absolute w-100 p-2 pt-0 rounded`}
        >
          <strong>{entity?.title}</strong>
          {/* {console.log(entity,"entity")} */}
          <div>
            <span className="badge bg-secondary me-2 fw-light">{entity?.duration}</span>
            <span className="badge bg-primary fw-light">
              <DatePosted date={channel?.created_at} format="YYYY" />
            </span>
          </div>
          <div className={`${styles.content}`}>
          <p className="m-0 mt-2">{entity?.description?.slice(0, 45)}{entity?.description?.length > 45 ? '...' : ''}</p>
          </div>
          {/* {entity.tags_list.length > 0 && (
            <div className={`${styles.badgesContainer} smooth mt-2`}>
              {entity.tags_list.map((tag, i) => {
                if (i <= 4)
                  return (
                    <Link
                      key={`entity_tag_${i}`}
                      className="bagde px-1 smooth rounded small"
                      to={`/tag-search?tag=${tag.id}&name=${tag.name}`}
                    >
                      #{tag.name}
                    </Link>
                  );
              })}
            </div>
          )} */}
        </div>

        {/* {entity.tags_list.length > 0 && (
          <div className={`${styles.badgesContainer} smooth`}>
            {entity.tags_list.map((tag, i) => {
              if (i <= 4)
                return (
                  <Link
                    key={`entity_tag_${i}`}
                    className="bagde px-1 smooth rounded"
                    to={`/tag-search?tag=${tag.id}&name=${tag.name}`}
                  >
                    #{tag.name}
                  </Link>
                );
            })}
          </div>
        )} */}
      </div>

      <FeedbackModal
        setFeedbackShow={setFeedbackShow}
        feedbackShow={feedbackShow}
        mediaItem={entity}
      />

      <ShareModal
        setShow={setShow}
        show={show}
        title={entity?.title}
        pageUrl={
          props.type === "podcast"
            ? `${window.location.origin}/${ROUTE_BASENAME}/podcaster/${entity?.uuid}`
            : `${window.location.origin}/${ROUTE_BASENAME}/in-house/${entity?.uuid}`
        }
      />
    </>
  );
}

export default MediaItem;

function ShareModal({ setShow, show, pageUrl, title }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body className="text-center">
          <p>Copy</p>
          <div className="p-2 rounded mt-3 content">{pageUrl}</div>
        </Modal.Body>
      </Modal>
    </>
  );
}

function FeedbackModal({ setFeedbackShow, feedbackShow, mediaItem }) {
  const handleClose = () => setFeedbackShow(false);
  const userData = useSelector((state) => state.auth.myProfile);
  const dispatch = useDispatch();
  const regSchema = Yup.object().shape({
    //subject: Yup.string().required("Subject is required"),
    description: Yup.string().trim().required("This field is required."),
  });

  return (
    <>
      <Modal
        backdrop="static"
        centered
        show={feedbackShow}
        onHide={handleClose}
      >
        <Modal.Header closeButton className="small">
          <Modal.Title className="h5">{mediaItem?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              subject: "",
              description: "",
              uuid: mediaItem?.uuid,
            }}
            validationSchema={regSchema}
            onSubmit={async (values) => {
              const payload = {
                feedback:
                  `<strong>${mediaItem?.title}</strong>` +
                  "\n\n" +
                  values.description,
                topic: values.subject,
                client_user: userData.client_user_details.id,
              };

              dispatch(sendFeedback(payload, "", false)).then(() => {
                handleClose();
              });
            }}
          >
            {({
              errors,
              touched,
              handleChange,
              handleBlur,
              values,
              setFieldValue,
              setFieldTouched,
              handleSubmit,
              isSubmitting,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <p>Your feedback is important to us!</p>
                  <Form.Control
                    type="hidden"
                    name="uuid"
                    value={values?.uuid}
                  ></Form.Control>
                  <FloatingLabel
                    controlId="floatingDescription"
                    label="Write your feedback here"
                  >
                    <Form.Control
                      type="text"
                      as="textarea"
                      style={{ minHeight: "200px" }}
                      placeholder="Write your feedback here"
                      name="description"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.description}
                      isInvalid={errors.description && touched.description}
                    />
                    {errors.description && touched.description && (
                      <div className="text-danger mt-1 small">
                        {errors.description}
                      </div>
                    )}
                  </FloatingLabel>
                  <hr />

                  <Button type="submit" variant="primary">
                    Submit Feedback
                  </Button>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}
